import { DATE_PIPE_DEFAULT_OPTIONS } from "@angular/common";
import { HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi } from "@angular/common/http";
import {
	ApplicationConfig,
	DEFAULT_CURRENCY_CODE,
	importProvidersFrom,
	provideZoneChangeDetection,
} from "@angular/core";
import { MAT_MENU_DEFAULT_OPTIONS } from "@angular/material/menu";
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from "@angular/material/snack-bar";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter, withHashLocation } from "@angular/router";
import { provideLoadingBarInterceptor } from "@ngx-loading-bar/http-client";
import { provideLoadingBarRouter } from "@ngx-loading-bar/router";
import { provideTranslateService, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { NgxGoogleAnalyticsModule } from "ngx-google-analytics";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { environment } from "src/environments/environment";
import { routes } from "./app.routes";
import { DEFAULT_LANGUAGE } from "./core/constants/constants";
import { authInterceptor } from "./core/interceptors/auth.interceptor";

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
	new TranslateHttpLoader(http, "./i18n/", ".json");

export const appConfig: ApplicationConfig = {
	providers: [
		provideAnimations(),
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes, withHashLocation()),
		provideHttpClient(withInterceptorsFromDi(), withInterceptors([authInterceptor])),
		provideLoadingBarRouter(),
		provideLoadingBarInterceptor(),
		provideTranslateService({
			defaultLanguage: DEFAULT_LANGUAGE,
			loader: {
				provide: TranslateLoader,
				useFactory: httpLoaderFactory,
				deps: [HttpClient],
			},
		}),
		{ provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { horizontalPosition: "right", verticalPosition: "top" } },
		{ provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { timezone: "+0300", dateFormat: "dd/MM/yyyy" } },
		{ provide: DEFAULT_CURRENCY_CODE, useValue: "KES" },
		{
			provide: MAT_MENU_DEFAULT_OPTIONS,
			useValue: { overlayPanelClass: "no-animations" },
		},
		importProvidersFrom([
			NgxGoogleAnalyticsModule.forRoot(environment.gaMeasurementId),
			NgxSkeletonLoaderModule.forRoot({ theme: { extendsFromRoot: true, "background-color": "#dfdfdf" } }),
		]),
	],
};
